import '../../index3.css';var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { jsx, Fragment, jsxs } from "react/jsx-runtime";
import * as React from "react";
import "../../Styling.js";
import "../../ReactResizeDetector.js";
import { DetailsListTypes, DetailsListDataTypes } from "./DetailsList.types.js";
import { DetailsHeader, ColumnActionsMode, DetailsListLayoutMode, ConstrainMode, CheckboxVisibility, DetailsRow, DetailsList as DetailsList$2, DetailsRowCheck } from "@fluentui/react/lib/DetailsList";
import { CheckboxVisibility as CheckboxVisibility2, ColumnActionsMode as ColumnActionsMode2, ColumnDragEndLocation, ConstrainMode as ConstrainMode2, DetailsColumn, DetailsHeader as DetailsHeader2, DetailsListLayoutMode as DetailsListLayoutMode2, DetailsRow as DetailsRow2, DetailsRowCheck as DetailsRowCheck2, DetailsRowFields, SelectAllVisibility } from "@fluentui/react/lib/DetailsList";
import "../../Selection.js";
import "../../Utilities.js";
import "../../ScrollablePane.js";
import { Stack } from "@fluentui/react/lib/Stack";
import { RESPONSIVE_BREAKPOINTS } from "../../styles/style.constants.js";
import { SelectionMode } from "@fluentui/react/lib/Selection";
import { css } from "@fluentui/utilities";
import { mergeStyles, getTheme, concatStyleSets } from "@fluentui/style-utilities";
import ReactResizeDetector__default from "react-resize-detector";
import { ScrollablePane } from "@fluentui/react/lib/ScrollablePane";
import { DetailsListLayout } from "./DetailsListLayout.js";
import "./DetailsListLayout.types.js";
import { DetailsListLoadingCell } from "./DetailsListLoadingCell.js";
import "./DetailsListLoadingCell.types.js";
import ___default from "lodash";
import "../ValidationError/index.js";
import "../Dropdown/index.js";
import { Grid } from "../Grid/Grid.js";
import { SearchBox as SearchBox$1 } from "@fluentui/react/lib/SearchBox";
import { IconButton } from "../Button/IconButton.js";
import { Dropdown } from "../Dropdown/Dropdown.js";
import { ValidationError } from "../ValidationError/ValidationError.js";
import { GridRow } from "../Grid/GridRow.js";
import { GridCol } from "../Grid/GridCol.js";
const DetailsList$1 = "";
const getDropdownOptions = (items) => {
  const placeholderDropdown = [{ key: "Any", text: "Any", disabled: false }];
  return placeholderDropdown.concat(
    items.map((item) => ({
      key: item,
      text: item,
      disabled: false
    }))
  );
};
const distinct = (value, index, self) => {
  return self.indexOf(value) === index;
};
const cleanQueryFunction = (value) => {
  if (value !== null && value !== void 0) {
    value = value.toString().toLowerCase();
    value = value.replace("'", "''");
    value = value.replace(/[^0-9a-z -_%.]/gi, "");
  }
  return value;
};
const putAndReturn = (dictionary, thisKey, value) => {
  dictionary = __spreadProps(__spreadValues({}, dictionary), {
    [thisKey]: value
  });
  return dictionary;
};
var dropDownList = [];
var dropDownValues = {};
var allFilters = {};
var oldContext = {};
var columnSortDirection = {};
var selectedSortColumn = "";
var canvas = document.createElement("canvas");
var ctx = canvas.getContext("2d");
const uiFont = "16px sans-serif";
function DetailsListFilterBar(props) {
  const { detailsListProps, onRenderAboveDetailsList, className } = props;
  const newProps = {
    items: detailsListProps.items,
    columns: detailsListProps.columns,
    ariaLabelForGrid: detailsListProps.ariaLabelForGrid,
    defaultSortColumn: detailsListProps.defaultSortColumn,
    onRenderItemColumn: detailsListProps.onRenderItemColumn,
    stickyHeader: true
  };
  const [detailProps, setDetailProps] = React.useState(newProps);
  const [stateDropdownList, setDropdownList] = React.useState(dropDownList);
  if (selectedSortColumn == "") {
    selectedSortColumn = detailsListProps.defaultSortColumn;
  }
  let AllFiltersKeys;
  ((AllFiltersKeys2) => {
    AllFiltersKeys2["query"] = "query";
  })(AllFiltersKeys || (AllFiltersKeys = {}));
  const generalFilter = ___default.debounce((itemList) => {
    const localQuery = allFilters[
      "query"
      /* query */
    ].length == 0 ? "" : allFilters[
      "query"
      /* query */
    ][0];
    if (localQuery !== "") {
      const cleanQuery = cleanQueryFunction(localQuery);
      const searchList = itemList.filter((item) => {
        for (let key of props.detailsListProps.columns.map((c) => c.key)) {
          if (item[key].searchString.toLowerCase().includes(cleanQuery)) {
            return true;
          }
        }
        return false;
      });
      updateDetailsListContents(searchList, false, false, true);
    } else {
      updateDropdownUrl();
    }
  });
  const dropDownKeys = Object.keys(props.detailsListStringProps);
  dropDownKeys.forEach((key) => {
    if (key in allFilters === false) {
      allFilters = putAndReturn(allFilters, key, []);
    }
    if (key in dropDownValues === false) {
      dropDownValues = putAndReturn(dropDownValues, key, "Any");
    }
  });
  if ("query" in allFilters === false) {
    allFilters = putAndReturn(allFilters, "query", []);
  }
  const updateQueryForList = ___default.debounce(
    (newQuery) => {
      if (newQuery !== void 0 && newQuery != "") {
        allFilters[
          "query"
          /* query */
        ] = [newQuery];
        generalFilter(getNewContents(detailsListProps.items));
      } else if (newQuery === void 0 || newQuery == "") {
        allFilters[
          "query"
          /* query */
        ] = [];
        updateDetailsListContents(detailsListProps.items, true, false, true);
      }
      updateUrl();
    },
    1250,
    { leading: false, trailing: true }
  );
  const getNewContents = (endContents) => {
    let contentKeys = Object.keys(allFilters);
    contentKeys.forEach((contentKey) => {
      if (contentKey != "query" && contentKey in allFilters && Array.isArray(allFilters[contentKey]) && allFilters[contentKey].length > 0) {
        const aDetailsListItem = endContents[0];
        if (aDetailsListItem !== void 0 && contentKey in aDetailsListItem) {
          const matchAgainst = allFilters[contentKey][0];
          endContents = endContents.filter((c) => c[contentKey].searchString == matchAgainst);
        }
      }
    });
    return endContents;
  };
  const updateDetailsListContents = (startingItems, getNew, changeDirection, fromSearch) => {
    var resultingItems = getNew ? getNewContents(startingItems) : startingItems;
    var modifiedListProps2 = {
      items: resultingItems,
      columns: detailsListProps.columns,
      ariaLabelForGrid: detailsListProps.ariaLabelForGrid,
      defaultSortColumn: detailsListProps.defaultSortColumn,
      onRenderItemColumn: detailsListProps.onRenderItemColumn,
      stickyHeader: true
    };
    if (modifiedListProps2.items.length > 0 && resultingItems.length > 0 && !(modifiedListProps2.items[0][selectedSortColumn] == resultingItems[0][selectedSortColumn]) || fromSearch == true) {
      modifiedListProps2 = getFilteredSortedProps(selectedSortColumn, modifiedListProps2, changeDirection);
      if (modifiedListProps2.items != resultingItems) {
        setDetailProps(modifiedListProps2);
      }
    }
  };
  const updateFiltersBasedOnUrl = () => {
    var theUrlParams = {};
    const contextKeys = Object.keys(props.userContext);
    const filterKeys = Object.keys(props.detailsListStringProps).concat([
      "query"
      /* query */
    ]);
    contextKeys.forEach((k) => {
      let val = props.userContext[k];
      theUrlParams[k] = val;
    });
    filterKeys.forEach((k) => {
      allFilters[k] = k in theUrlParams ? theUrlParams[k] === void 0 || theUrlParams[k] === null ? [] : [theUrlParams[k]] : allFilters[k];
    });
    updateDetailsListContents(detailsListProps.items, true, true, false);
  };
  if (ctx !== null && ctx.font != uiFont) {
    ctx.font = uiFont;
  }
  const getLabelLengthNumber = (label) => {
    var labelLength = 150;
    if (ctx !== null) {
      labelLength = Math.max(Math.ceil(ctx.measureText(label).width) + 1, labelLength);
    }
    return labelLength;
  };
  const getOptionLength = (options, labelLength) => {
    var minLength = Math.max(150, labelLength);
    options.forEach((dropdownOptionText) => {
      if (ctx !== null) {
        minLength = Math.max(minLength, Math.ceil(ctx.measureText(dropdownOptionText).width) + 1);
      }
    });
    return minLength;
  };
  const createDropdowns = () => {
    dropDownList = [];
    let dropdownOptionKeys = Object.keys(props.detailsListStringProps);
    dropdownOptionKeys.forEach((key) => {
      const uncasedAriaLabel = key + " dropdown";
      const ariaLabel = uncasedAriaLabel.charAt(0).toUpperCase() + uncasedAriaLabel.slice(1);
      const setOfElements = key in props.detailsListStringProps && Array.isArray(props.detailsListStringProps[key]) && props.detailsListStringProps[key].length > 0 ? props.detailsListStringProps[key].filter(distinct) : [];
      var dropdownListOptions = getDropdownOptions(setOfElements);
      var placeholder = key in allFilters && Array.isArray(allFilters[key]) && allFilters[key].length > 0 && allFilters[key][0] !== void 0 && allFilters[key][0] !== null ? allFilters[key][0] : "Any";
      if (placeholder === void 0 || placeholder === null) {
        placeholder = "Any";
      }
      dropDownValues[key] = placeholder;
      const labelLength = getLabelLengthNumber(props.detailsListDropdownTextLabels[key]);
      const longestOptionLength = getOptionLength(
        dropdownListOptions.map((o) => o.text),
        labelLength
      );
      const dropdownElement = /* @__PURE__ */ jsx(
        Dropdown,
        {
          style: { minWidth: labelLength.toString() + "px", maxWidth: "400px" },
          calloutProps: {
            calloutMinWidth: longestOptionLength
          },
          label: props.detailsListDropdownTextLabels[key],
          disabled: false,
          ariaLabel,
          options: dropdownListOptions,
          defaultSelectedKey: allFilters[key].length > 0 ? allFilters[key][0] : dropdownListOptions[0].key,
          placeholder,
          onChange: (e, option) => {
            if (option !== void 0) {
              dropDownValues[key] = option.key;
              if (option.key !== "Any") {
                updateFilters(key, [option.key]);
              } else {
                updateFilters(key, []);
              }
              const endContents = getNewContents(detailsListProps.items);
              var modifiedListProps2 = {
                items: endContents,
                columns: detailsListProps.columns,
                ariaLabelForGrid: detailsListProps.ariaLabelForGrid,
                defaultSortColumn: detailsListProps.defaultSortColumn,
                onRenderItemColumn: detailsListProps.onRenderItemColumn,
                stickyHeader: true
              };
              modifiedListProps2 = getFilteredSortedProps(selectedSortColumn, modifiedListProps2, false);
              setDetailProps(modifiedListProps2);
              generalFilter(endContents);
              updateUrl();
            }
          }
        },
        props.detailsListDropdownTextLabels[key]
      );
      dropDownList.push(dropdownElement);
      setDropdownList(dropDownList);
    });
  };
  const updateDropdownUrl = () => {
    var newContext = {};
    let filterKeys = Object.keys(allFilters);
    filterKeys.forEach((k) => {
      newContext = putAndReturn(newContext, k, Array(allFilters[k]).length > 0 ? allFilters[k][0] : void 0);
    });
    compareCurrentContext(oldContext) === false && props.setPartialUserContext !== void 0 && props.setPartialUserContext(newContext);
  };
  const updateUrl = () => {
    const localQuery = allFilters[
      "query"
      /* query */
    ].length == 0 ? "" : allFilters[
      "query"
      /* query */
    ][0];
    var newContext = {};
    let filterKeys = Object.keys(allFilters);
    filterKeys.forEach((k) => {
      newContext = putAndReturn(newContext, k, Array(allFilters[k]).length > 0 ? allFilters[k][0] : void 0);
    });
    newContext = putAndReturn(newContext, "query", localQuery);
    compareCurrentContext(newContext) === false && props.setPartialUserContext !== void 0 && props.setPartialUserContext(newContext);
  };
  const updateFilters = (key, value) => {
    allFilters = putAndReturn(allFilters, key, value);
  };
  const onRenderDetailsHeader = (props2) => {
    if (!props2)
      return null;
    return /* @__PURE__ */ jsx(
      DetailsHeader,
      __spreadValues({
        styles: {
          root: {
            paddingTop: 0
          }
        }
      }, props2)
    );
  };
  const _renderValidationErrors = () => {
    const { errors } = props;
    if (!(errors == null ? void 0 : errors.length)) {
      return null;
    }
    return /* @__PURE__ */ jsx("div", { children: ___default.map(errors, (error, i) => {
      return /* @__PURE__ */ jsx(ValidationError, { children: error }, i);
    }) });
  };
  const getDefaultSortColumnWithProps = (detailListProps) => {
    const thisDefaultSortColumn = detailListProps.defaultSortColumn;
    const foundDefaultSortColumn = detailListProps.columns.find((c) => c.key === thisDefaultSortColumn);
    return foundDefaultSortColumn;
  };
  const updateColumnDirection = (columnName) => {
    columnSortDirection = __spreadProps(__spreadValues({}, columnSortDirection), { [columnName]: !columnSortDirection[columnName] });
  };
  const getColumnSortDirection = (columnName, changeDirection) => {
    if (changeDirection == true && columnSortDirection[columnName] !== void 0) {
      updateColumnDirection(columnName);
    }
    if (columnSortDirection[columnName] === void 0) {
      columnSortDirection = __spreadProps(__spreadValues({}, columnSortDirection), { [columnName]: false });
    }
    const currentDirection = columnSortDirection[columnName];
    return currentDirection;
  };
  const copyAndSort = (items, columnKey, isSortedDescending) => {
    const key = columnKey;
    const slicedItems = [...items];
    return slicedItems.sort(
      (a, b) => (isSortedDescending ? DetailsList._compare(a[key].content, b[key].content) : DetailsList._compare(b[key].content, a[key].content)) ? 1 : -1
    );
  };
  const sortExistingData = (columnName, inputData, changeDirection) => {
    const testSort = copyAndSort(inputData.items, columnName, getColumnSortDirection(columnName, changeDirection));
    return testSort;
  };
  const getFilteredSortedProps = (column, inputData, changeDirection) => {
    const testNewSort = sortExistingData(column, inputData, changeDirection);
    const modifiedListProps2 = {
      items: testNewSort,
      columns: inputData.columns,
      ariaLabelForGrid: inputData.ariaLabelForGrid,
      defaultSortColumn: inputData.defaultSortColumn,
      onRenderItemColumn: inputData.onRenderItemColumn,
      stickyHeader: true
    };
    return modifiedListProps2;
  };
  const onColumnClickForSearchableDetailsList = (ev, column) => {
    var _a;
    const columnToSort = (_a = column == null ? void 0 : column.key) != null ? _a : detailsListProps.defaultSortColumn;
    selectedSortColumn = columnToSort;
    setDetailProps(getFilteredSortedProps(columnToSort, detailProps, true));
  };
  if (stateDropdownList.length < 1) {
    updateFiltersBasedOnUrl();
    createDropdowns();
    const newEndContents = getNewContents(detailsListProps.items);
    var modifiedListProps = {
      items: newEndContents,
      columns: detailsListProps.columns,
      ariaLabelForGrid: detailsListProps.ariaLabelForGrid,
      defaultSortColumn: detailsListProps.defaultSortColumn,
      onRenderItemColumn: detailsListProps.onRenderItemColumn,
      stickyHeader: true
    };
    if (newEndContents != detailsListProps.items) {
      setDetailProps(getFilteredSortedProps(selectedSortColumn, modifiedListProps, false));
    }
    const thisQuery = allFilters[
      "query"
      /* query */
    ].length == 0 ? "" : allFilters[
      "query"
      /* query */
    ][0];
    updateQueryForList(thisQuery);
    generalFilter(newEndContents);
  }
  const compareCurrentContext = (thisContext) => {
    const allFilterKeys = Object.keys(allFilters);
    if (thisContext === {}) {
      var moreThanUndefined = false;
      allFilterKeys.forEach((key) => {
        if (props.userContext[key] !== void 0) {
          moreThanUndefined = true;
        }
      });
      if (moreThanUndefined) {
        return false;
      }
      return true;
    }
    var allTheSame = true;
    allFilterKeys.forEach((k) => {
      if (thisContext[k] !== props.userContext[k]) {
        if (!(thisContext[k] == null && props.userContext[k] === void 0) && !(thisContext[k] === void 0 && props.userContext[k] == null)) {
          if (!(k === "query" && thisContext[k] == "" && props.userContext[k] === void 0 || k === "query" && thisContext[k] === void 0 && props.userContext[k] == "")) {
            allTheSame = false;
          }
        }
      }
    });
    return allTheSame;
  };
  if (compareCurrentContext(oldContext) === false) {
    columnSortDirection = {};
    selectedSortColumn = detailsListProps.defaultSortColumn;
    if (oldContext != props.userContext) {
      oldContext = props.userContext;
      setDropdownList([]);
    }
  }
  const emptySearchText = "Filter metric movements by keyword";
  const searchBoxText = allFilters[
    "query"
    /* query */
  ].length == 0 ? emptySearchText : allFilters[
    "query"
    /* query */
  ][0];
  return /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsx(
    Stack,
    {
      className: mergeStyles("ane-Dropdown", {
        height: "100%",
        flexFlow: "row",
        display: "flex",
        paddingLeft: "10px",
        paddingRight: "10px",
        minWidth: "max-content"
      }),
      children: /* @__PURE__ */ jsxs(Grid, { children: [
        /* @__PURE__ */ jsxs(
          GridRow,
          {
            style: {
              maxWidth: "fit-content"
            },
            children: [
              props.hasSearchBar == true && /* @__PURE__ */ jsx(
                SearchBox$1,
                {
                  ariaLabel: "Filter list by keyword",
                  className: mergeStyles({ maxWidth: "400px", minWidth: "275px", margin: "30px" }),
                  placeholder: searchBoxText,
                  onChange: (ev, newValue) => {
                    const stringNewValue = newValue !== void 0 ? newValue : "";
                    updateQueryForList(stringNewValue);
                  }
                }
              ),
              stateDropdownList.map((thisDropdown) => /* @__PURE__ */ jsxs(GridCol, { children: [
                " ",
                thisDropdown,
                " "
              ] })),
              /* @__PURE__ */ jsx(
                IconButton,
                {
                  ariaLabel: "Reset the search and dropdown filters",
                  iconProps: { iconName: "Clear" },
                  onClick: () => {
                    var emptyQueryPartialContext = {};
                    emptyQueryPartialContext = putAndReturn(emptyQueryPartialContext, "query", "");
                    props.setPartialUserContext !== void 0 && props.setPartialUserContext(emptyQueryPartialContext);
                    let dropDownValueKeys = Object.keys(dropDownValues);
                    dropDownValueKeys.forEach((ddk) => {
                      dropDownValues = putAndReturn(dropDownValues, ddk, "Any");
                      updateFilters(ddk, []);
                    });
                    allFilters = putAndReturn(allFilters, "query", []);
                    updateQueryForList("");
                    columnSortDirection = {};
                    selectedSortColumn = detailsListProps.defaultSortColumn;
                    updateUrl();
                    createDropdowns();
                    setDetailProps(__spreadValues({}, getFilteredSortedProps(selectedSortColumn, newProps, false)));
                    onColumnClickForSearchableDetailsList(void 0, getDefaultSortColumnWithProps(newProps));
                  }
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ jsx(GridRow, { children: /* @__PURE__ */ jsx(Stack, { grow: 1, className, tokens: { childrenGap: 10 } }) }),
        /* @__PURE__ */ jsxs(
          GridRow,
          {
            style: {
              height: "100%",
              display: "flex",
              paddingLeft: "10px",
              paddingRight: "10px",
              minWidth: "max-content"
            },
            children: [
              onRenderAboveDetailsList && onRenderAboveDetailsList(),
              /* @__PURE__ */ jsx(
                DetailsList,
                __spreadValues({
                  onShouldVirtualize: () => {
                    return true;
                  },
                  onRenderDetailsHeader,
                  onColumnClick: onColumnClickForSearchableDetailsList
                }, detailProps)
              ),
              _renderValidationErrors()
            ]
          }
        )
      ] })
    }
  ) });
}
const defaultClassName = "ane-DetailsList";
const _DetailsList = class _DetailsList extends React.PureComponent {
  constructor(props) {
    super(props);
    __publicField(this, "_onRenderRowCheckBox", (props, rowProps) => {
      return /* @__PURE__ */ jsx(DetailsRowCheck, __spreadProps(__spreadValues({}, props), { onClick: (ev) => ev.preventDefault() }));
    });
    __publicField(this, "_onRenderDetailsHeader", (props) => {
      if (!props)
        return null;
      return /* @__PURE__ */ jsx(
        DetailsHeader,
        __spreadValues({
          styles: {
            root: {
              paddingTop: 0
            }
          }
        }, props)
      );
    });
    __publicField(this, "_onRenderItemColumn", (item, index, column) => {
      if (!column)
        return null;
      const { onRenderItemColumn } = this.props;
      const { onRender = onRenderItemColumn } = item;
      const fieldContent = onRender ? onRender(item, index, column) : item[column.fieldName];
      switch (column.dataType) {
        case DetailsListDataTypes.number:
          return /* @__PURE__ */ jsx("span", { className: mergeStyles({ textAlign: "right", display: "block" }), children: fieldContent });
        default:
          return /* @__PURE__ */ jsx("span", { children: fieldContent });
      }
    });
    __publicField(this, "_onColumnClick", (ev, column) => {
      const { onColumnClick } = this.props;
      !!onColumnClick && onColumnClick(ev, column);
      if (!ev.defaultPrevented) {
        const { columns, items } = this.props;
        if (!columns)
          return;
        this.setState(_DetailsList.getItemsAndColumnsSortedByColumnKey(columns, items, column.key));
      }
    });
    const { items, columns, defaultSortColumn } = this.props;
    const defaultColumn = columns.find((currCol) => defaultSortColumn === currCol.key);
    this.state = defaultSortColumn === "" ? { items, columns } : _DetailsList.getItemsAndColumnsSortedByColumnKey(columns, items, defaultSortColumn, defaultColumn == null ? void 0 : defaultColumn.isSortedDescending);
  }
  static getDerivedStateFromProps(props, state) {
    var _a;
    const sortedColumn = (_a = state.columns) == null ? void 0 : _a.find((c) => c.isSorted);
    const { columns, items } = props;
    if (props.items !== state.items || columns !== state.columns) {
      if (sortedColumn) {
        return _DetailsList.getItemsAndColumnsSortedByColumnKey(
          columns,
          props.items,
          sortedColumn.key,
          sortedColumn.isSortedDescending
        );
      } else {
        return { columns, items };
      }
    } else {
      return null;
    }
  }
  render() {
    const {
      selectionMode = SelectionMode.none,
      detailsListType = DetailsListTypes.default,
      onRenderDetailsHeader = this._onRenderDetailsHeader,
      disableSort
    } = this.props;
    const { items, columns = [] } = this.state;
    const defaultColumns = columns.map((column) => __spreadProps(__spreadValues({
      /**
       * a11y
       * Using ColumnActionsMode.disabled is the proper way to disable columns for a11y
       */
      columnActionsMode: disableSort || column.disableSort ? ColumnActionsMode.disabled : column.columnActionsMode
    }, column), {
      onColumnClick: this._onColumnClick,
      /**
       * use the dataType prop to determine the header cell alignment
       */
      headerClassName: css(
        "ane-DetailsList-Header",
        column.headerClassName,
        column.dataType === DetailsListDataTypes.number ? "ane-DetailsList-Header_right" : "ane-DetailsList-Header_left"
      )
    }));
    const layoutMode = this.props.layoutMode || (this.props.stickyHeader ? DetailsListLayoutMode.fixedColumns : DetailsListLayoutMode.justified);
    const constrainMode = this.props.constrainMode || (this.props.stickyHeader ? ConstrainMode.unconstrained : ConstrainMode.horizontalConstrained);
    const theme = getTheme();
    const styleOverride = __spreadValues({
      root: {
        selectors: {
          ".ms-DetailsRow": __spreadValues({
            selectors: {
              "& a": {
                textDecoration: "underline"
              },
              "& .is-selected": {
                backgroundColor: theme.semanticColors.bodyBackgroundHovered,
                selectors: { ":focus": { backgroundColor: `${theme.semanticColors.bodyBackgroundHovered} !important` } }
              },
              ":focus": { backgroundColor: "unset" }
            }
          }, this.props.stickyHeader && { minWidth: "100% !important" })
        }
      }
    }, this.props.stickyHeader ? {
      headerWrapper: {
        position: "sticky",
        top: 0,
        zIndex: 1
      }
    } : {});
    const styles = concatStyleSets(styleOverride, this.props.styles);
    const defaultCheckboxVisibility = CheckboxVisibility.always;
    const {
      checkboxVisibility = defaultCheckboxVisibility,
      ariaLabelForSelectAllCheckbox = "Toggle selection for all items",
      checkButtonAriaLabel = !!this.props.ariaLabelForGrid ? `${this.props.ariaLabelForGrid} row checkbox` : "Row checkbox",
      checkButtonGroupAriaLabel = !!this.props.ariaLabelForGrid ? `${this.props.ariaLabelForGrid} group checkbox` : "Group checkbox",
      onRenderRow = (props) => /* @__PURE__ */ jsx(DetailsRow, __spreadProps(__spreadValues({}, props), { onRenderCheck: (p) => this._onRenderRowCheckBox(p, props) }))
    } = this.props;
    const detailsList = /* @__PURE__ */ jsx(
      DetailsList$2,
      __spreadProps(__spreadValues({}, this.props), {
        ariaLabelForSelectAllCheckbox,
        checkButtonAriaLabel,
        checkButtonGroupAriaLabel,
        onRenderRow,
        styles,
        className: css(defaultClassName, `${defaultClassName}-${detailsListType}`),
        onRenderDetailsHeader,
        constrainMode,
        layoutMode,
        items,
        columns: defaultColumns,
        isHeaderVisible: true,
        selectionMode,
        selectionPreservedOnEmptyClick: true,
        enterModalSelectionOnTouch: true,
        listProps: { className: "TestClassName", items },
        onRenderItemColumn: this._onRenderItemColumn,
        checkboxVisibility
      })
    );
    const listContent = this.props.stickyHeader ? /* @__PURE__ */ jsx(
      ReactResizeDetector__default,
      {
        handleWidth: true,
        handleHeight: true,
        refreshMode: "throttle",
        render: () => {
          const setFixedHeight = window.innerWidth <= RESPONSIVE_BREAKPOINTS.md;
          return /* @__PURE__ */ jsx(
            "div",
            {
              className: mergeStyles("ane-DetailsList-stickyHeader", {
                position: "relative",
                width: "100%",
                height: setFixedHeight ? `${window.innerHeight}px` : "100%"
              }),
              children: /* @__PURE__ */ jsx(ScrollablePane, { children: detailsList })
            }
          );
        }
      }
    ) : detailsList;
    const className = mergeStyles("ane-DetailsList-gridContainer");
    return /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsx(Stack, { verticalFill: true, grow: 1, className: mergeStyles("ane-DetailsList-container", this.props.className), children: /* @__PURE__ */ jsx(Stack, { verticalFill: true, grow: 1, className, children: listContent }) }) });
  }
};
__publicField(_DetailsList, "getItemsAndColumnsSortedByColumnKey", (columns, items, key, isSortedDescending) => {
  const newColumns = columns.slice();
  const currColumn = newColumns.find((currCol) => key === currCol.key);
  newColumns.forEach((newCol) => {
    if (currColumn && newCol === currColumn) {
      currColumn.isSortedDescending = isSortedDescending !== void 0 ? isSortedDescending : !currColumn.isSortedDescending;
      currColumn.isSorted = true;
    } else {
      newCol.isSorted = false;
      newCol.isSortedDescending = true;
    }
    if (newCol.isSortedDescending) {
      newCol.sortDescendingAriaLabel = "Sorted from descending to ascending";
    } else {
      newCol.sortAscendingAriaLabel = "Sorted from ascending to descending";
    }
  });
  const newItems = !currColumn ? items : _DetailsList.copyAndSort(items, currColumn.fieldName, currColumn.isSortedDescending);
  return { columns: newColumns, items: newItems };
});
__publicField(_DetailsList, "_compare", (var1, var2) => {
  if (typeof var1 === "string" && typeof var2 === "string") {
    return var1.toUpperCase() < var2.toUpperCase();
  } else {
    return var1 < var2;
  }
});
__publicField(_DetailsList, "copyAndSort", (items, columnKey, isSortedDescending) => {
  const key = columnKey;
  return items.slice(0).sort(
    (a, b) => (isSortedDescending ? _DetailsList._compare(a[key], b[key]) : _DetailsList._compare(b[key], a[key])) ? 1 : -1
  );
});
let DetailsList = _DetailsList;
export {
  CheckboxVisibility2 as CheckboxVisibility,
  ColumnActionsMode2 as ColumnActionsMode,
  ColumnDragEndLocation,
  ConstrainMode2 as ConstrainMode,
  DetailsColumn,
  DetailsHeader2 as DetailsHeader,
  DetailsList,
  DetailsListDataTypes,
  DetailsListFilterBar,
  DetailsListLayout,
  DetailsListLayoutMode2 as DetailsListLayoutMode,
  DetailsListLoadingCell,
  DetailsListTypes,
  DetailsRow2 as DetailsRow,
  DetailsRowCheck2 as DetailsRowCheck,
  DetailsRowFields,
  SelectAllVisibility,
  cleanQueryFunction,
  distinct,
  getDropdownOptions,
  putAndReturn
};
//# sourceMappingURL=index.js.map
